import React, { FC, useContext, createContext, PropsWithChildren } from 'react'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

export type NetworkContextDefaults = Partial<{
  /**
   * send with headers to api for debugging, reflects latest tag deployed
   */
  version: string
  /**
   * send with headers to api for debugging, should be "Web"
   */
  platform: string
  /**
   * string to prefix request urls
   */
  baseUrl: string
  /**
   * callback which decides whether to use error boundary or not
   */
  errorBoundaryHandler: (error: any) => boolean

  /**
   * default token for Authorization header
   */
  token: string
}>

export interface NetworkContextProviderProps {
  client: QueryClient
  defaults: NetworkContextDefaults
}

export const NetworkContext = createContext({} as NetworkContextDefaults)

export const useNetworkContext = () => useContext(NetworkContext)

export const NetworkProvider: FC<
  NetworkContextProviderProps & PropsWithChildren
> = ({ children, client, defaults }) => (
  <NetworkContext.Provider {...{ value: defaults }}>
    <QueryClientProvider {...{ client }}>{children}</QueryClientProvider>
  </NetworkContext.Provider>
)
